import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient } from '@app/api/api-client';
import { ApiTypes } from '@app/api/api-types';
import { Api } from '@app/api/generated/api';

export type AiTranslateTargetType = 'accounts' | 'venues';

@Service()
export class AiTranslateBackendService {
  private readonly api = inject(ApiClient);

  translate$(
    targetType: AiTranslateTargetType,
    targetUuid: string,
    body: ApiTypes.TranslateRequestDto
  ): Observable<ApiTypes.TranslateResponseDto> {
    return this.api.post(Api.surveys.ai.translate, {
      pathParams: { targetType, targetUuid },
      body,
    });
  }
}
